var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor probel-get-patient-token" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "probel-get-patient-token-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [
        _vm._v(_vm._s(_vm.$t("probel.identityType"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("probel.identityTypeDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.identityType,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "identityType", $$v)
              },
              expression: "clone.identityType",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle mt-2" }, [
        _vm._v(_vm._s(_vm.$t("probel.identityNumber"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("probel.identityNumberDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.identityNumber,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "identityNumber", $$v)
              },
              expression: "clone.identityNumber",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle mt-2" }, [
        _vm._v(_vm._s(_vm.$t("probel.name"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("probel.nameDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.name,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "name", $$v)
              },
              expression: "clone.name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle mt-2" }, [
        _vm._v(_vm._s(_vm.$t("probel.surname"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("probel.surnameDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.surname,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "surname", $$v)
              },
              expression: "clone.surname",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle mt-2" }, [
        _vm._v(_vm._s(_vm.$t("probel.gender"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("probel.genderDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.gender,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "gender", $$v)
              },
              expression: "clone.gender",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle mt-2" }, [
        _vm._v(_vm._s(_vm.$t("probel.birthDay"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("probel.birthDayDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.birthDay,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "birthDay", $$v)
              },
              expression: "clone.birthDay",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle mt-2" }, [
        _vm._v(_vm._s(_vm.$t("probel.phoneNumber"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("probel.phoneNumberDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.phoneNumber,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "phoneNumber", $$v)
              },
              expression: "clone.phoneNumber",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "inputTitle mt-5 mb-2 font-weight-bold" }, [
      _vm._v(_vm._s(_vm.$t("chatbotv2.followingAttributesFilled"))),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "next-step-filled-items-wrapper" },
      _vm._l(_vm.nextStepFilledValue, function (attr) {
        return _c(
          "div",
          { key: attr, staticClass: "logos middle-section" },
          [
            _c("AttributeIconPreview", { attrs: { attribute: attr } }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ml-2" },
              [_c("AttributeLabel", { attrs: { attribute: attr } })],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "active-connection" }, [
      _c("div", { staticClass: "logos", attrs: { "data-small": "true" } }, [
        _c("div", { staticClass: "logo1" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/supsis-logo2.png" },
          }),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
        _vm._v(" "),
        _c("div", { staticClass: "logo2" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/chatbot/probel.png" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "active-connection-text" }, [
        _c("div", [
          _c("span", [_vm._v("Connected with")]),
          _vm._v(" "),
          _c("b", [_vm._v(" Probel API")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }